import React from 'react'
import SmartImage from '../SmartImage';

const PreLoader = (props) => {
    return (
        <div className="preloade-box">
            <SmartImage width={60} src={process.env.REACT_APP_BASE_URL + 'images/logo-1723459912706.png'} />
            <div id='loader'>
                {/* <SmartImage src={process.env.REACT_APP_BASE_URL + 'images/' + props.siteInfo.logo} alt={props.siteInfo.compName} title={props.siteInfo.compName} /> */}
            </div>
            
        </div>
    )
}

export default PreLoader
